import { useCallback } from "react";
import { useMsal } from "@azure/msal-react";
import { useNavigate } from "react-router-dom";
import { AuthService } from "../services";
import { useUserContext } from "../context/UserContext";

//TODO: MOVE TO SHARED UI
export function useLogout() {
    const { instance } = useMsal();
    const navigate = useNavigate();
    const { setUser } = useUserContext();

    return useCallback(async () => {
        await AuthService.logout()
            .then(() => {
                setUser(null);

                const activeAccount = instance.getActiveAccount();

                if(activeAccount){
                    instance.setActiveAccount(null);
                    instance.logoutRedirect({
                        postLogoutRedirectUri: window.location.origin,
                    });
                } else {
                    navigate("/");
                }
            })
            .catch((error) => {
                console.log(error);
            });
    }, [instance, setUser, navigate]);
}